// Frame wrapper for an input carrying a unit, icon or inline action. The
// wrapper owns the border and the focus ring; the nested Input goes borderless.
function unit(node) {
  if (node == null || node === false) return null;
  if (typeof node === "string" || typeof node === "number") {
    return <span className="peb-input-affix__unit">{node}</span>;
  }
  return node;
}

export default function InputAffix({
  prefix,
  suffix,
  error = false,
  readOnly = false,
  disabled = false,
  className = "",
  children,
  ...rest
}) {
  const classes = [
    "peb-input-affix",
    error ? "peb-input-affix--error" : "",
    readOnly ? "peb-input-affix--readonly" : "",
    disabled ? "peb-input-affix--disabled" : "",
    className,
  ].filter(Boolean).join(" ");
  return (
    <div className={classes} {...rest}>
      {unit(prefix)}
      {children}
      {unit(suffix)}
    </div>
  );
}
